import * as API from '../'
export default {
  //工单
  pageList: params => {
    return API.GET('/api/workorder/pagelist',params)
  },
  saveWorkOrder: params => {
  	return API.POST('/api/workorder/save',params)
  },
  updateWorkOrder: params => {
  	return API.PUT('/api/workorder/update',params)
  },
  removeWorkOrder: id => {
  	return API.DELETE('/api/workorder/remove/' + id)
  },
  getPushList:params =>{
    return API.GET('/api/workorder/getPushList',params)
  },
  rePush:params =>{
    return API.postJsonRequest('/api/workorder/rePush',params)
  },
  getImageList:params =>{
    return API.GET('/api/workorder/imgList',params)
  }
}


// WEBPACK FOOTER //
// ./src/api/device/api_workorder.js